import * as Yup from "yup";

const requiredMessage = "El campo es requerido";

export const personalDataSchema = Yup.object({
  name: Yup.string().trim().required(requiredMessage),
  email: Yup.string()
    .trim()
    .email("Ingrese un correo electrónico válido")
    .required(requiredMessage),
  phone: Yup.string()
    .trim()
    .required(requiredMessage)
    .test(
      "chilean-mobile",
      "Ingresa un teléfono chileno válido, por ejemplo +569 87654321",
      (value) =>
        !value || /^\+569\d{8}$/.test(value.replace(/[\s-]/g, ""))
    ),
});

export const profileSchema = Yup.object({
  region: Yup.string().required(requiredMessage),
  occupation: Yup.string().notRequired(),
  project_name: Yup.string().trim().required(requiredMessage),
});

export const diagnosisSchema = Yup.object({
  obstacle: Yup.string().required(requiredMessage),
  experience: Yup.string().required(requiredMessage),
  expectation: Yup.string().required(requiredMessage),
});

export const confirmationSchema = Yup.object({
  legal_terms_accepted: Yup.boolean().oneOf(
    [true],
    "Debes aceptar las bases y el tratamiento de datos"
  ),
});

export const stepSchemas = [
  personalDataSchema,
  profileSchema,
  diagnosisSchema,
  confirmationSchema,
];

export const stepFieldNames = [
  ["name", "email", "phone"],
  ["region", "occupation", "project_name"],
  ["obstacle", "experience", "expectation"],
  ["legal_terms_accepted"],
];
